import {
  CourseQuizDataInProgressInterface,
  CourseQuizDataResultInterface,
} from '../types/course-quiz-interface'

export const isCourseQuizDataResult = (
  data: CourseQuizDataInProgressInterface | CourseQuizDataResultInterface,
): data is CourseQuizDataResultInterface => 'c' in data.q[0].a[0]
